<div class="flex gap-6">
  <!-- Left Panel - Payment Methods List -->
  <div class="w-1/3 flex flex-col gap-6">
    <div class="border border-outline rounded-3 p-4">
      <h3 class="text-lg font-medium mb-4">Payment Methods</h3>
      
      @if (isLoadingList()) {
        <div class="flex justify-center p-4">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      } @else {
        <div class="space-y-2">
          @for (method of paymentMethods(); track method.id) {
            <div 
              class="p-3 border rounded-2 cursor-pointer transition-colors hover:bg-gray-50 {{ selectedPaymentMethod()?.id === method.id ? 'border-primary bg-primary-50' : 'border-gray-200' }}"
              (click)="selectPaymentMethod(method)"
            >
              <div class="flex items-center gap-3">
                @if (method.image && method.image.url) {
                  <img [src]="method.image.url" [alt]="method.name.english || ''" class="w-8 h-8 object-cover rounded">
                } @else {
                  <div class="w-8 h-8 bg-gray-200 rounded flex items-center justify-center">
                    <cac-icon icon="credit-card" size="1rem"></cac-icon>
                  </div>
                }
                <div class="flex-1">
                  <div class="font-medium text-sm">{{ method.name.english || method.name.arabic }}</div>
                  <div class="text-xs text-gray-500">
                    {{ method.status === 1 ? 'Active' : 'Inactive' }}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Right Panel - Payment Method Details -->
  <div class="payment-method-details flex-auto col-span-2 justify-center mr-8 border border-outline rounded-3 p-8 {{ isLoadingMethod() ? 'opacity-50 pointer-events-none' : '' }}">
    @if (selectedPaymentMethod()) {
      <div class="space-y-6">
        <!-- Image Upload Section -->
        <div class="flex gap-2">
          <cac-image-uploader 
            [control]="form.controls.image" 
            label="Image" 
            class="h-36 w-36" 
          />
        </div>

        <!-- Form Fields -->
        <div class="grid grid-cols-2 gap-x-6 gap-y-4 w-full">
          <cac-field 
            autoComplete="false" 
            [control]="form.controls.englishName" 
            label="English Name"
          ></cac-field>
          
          <cac-field 
            autoComplete="false" 
            [control]="form.controls.arabicName" 
            label="Arabic Name"
          ></cac-field>
          
          <cac-switch 
            [control]="form.controls.status" 
            label="Active"
          ></cac-switch>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Type</label>
            <div class="p-3 bg-gray-50 rounded border text-sm text-gray-600">
              {{ getPaymentMethodTypeName(selectedPaymentMethod()!.type) }}
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-end gap-4 pt-4">
          <cac-button 
            (onClick)="onSubmit($event)" 
            class="w-32"
            [disabled]="!form.valid"
          >
            Update
          </cac-button>
        </div>
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center h-64 text-gray-500">
        <cac-icon icon="credit-card" size="3rem" class="mb-4"></cac-icon>
        <p class="text-lg">Select a payment method to edit</p>
        <p class="text-sm">Choose a payment method from the list to view and edit its details</p>
      </div>
    }
  </div>
</div>
